(function (Drupal, once) {

  'use strict';

  Drupal.behaviors.mainMenu = {
    attach(context) {
      once('mainMenu', '.main-menu__links .main-menu__links__item.dropdown', context).forEach((el) => {
        const toggle = el.querySelector('.dropdown-toggle');
        if (!toggle) {
          return;
        }

        toggle.setAttribute('aria-expanded', 'false');

        // Focus → toggle dropdown.
        toggle.addEventListener('focus', (e) => {
          // Delay to reduce double-triggering with click event.
          setTimeout(() => {
            toggleDropdown(el);
          }, 100);
        });

        // Blur on any <a> inside item.
        el.querySelectorAll('a').forEach((link) => {
          link.addEventListener('blur', () => {
            // Wait for next element to gain focus.
            setTimeout(() => {
              const openMenu = el.querySelector('.dropdown-menu.show');

              // Check if focused element is still inside expanded menu.
              if (openMenu && !openMenu.contains(document.activeElement)) {
                openMenu.classList.remove('show');
                toggle.setAttribute('aria-expanded', 'false');
              }
            }, 10);
          });
        });
      });
    }
  };

  /**
   * Minimal dropdown toggle (Bootstrap-like).
   */
  function toggleDropdown(container) {
    const toggle = container.querySelector('.dropdown-toggle');
    const menu = container.querySelector('.dropdown-menu');

    if (!toggle || !menu) {
      return;
    }

    const isOpen = menu.classList.contains('show');

    menu.classList.toggle('show', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
  }
})(Drupal, once);
